import { Box, Skeleton } from '@mui/material'
import { VideoPlayerSkeleton } from 'src/v3/classroom-v2/components/video-player'

// What stands in for a step while the wizard works out which one the learner
// belongs on. That gap is real — content and progress load independently, and the
// middleware lands the learner on the first incomplete step only once both have
// settled — but it is a WAIT, not a choice. It used to render "Select a step to
// begin", which described a state this wizard doesn't have: there is no landing
// state where nothing is selected, because the phase gate always resolves to
// something, and inviting a choice implies a step the learner picks rather than one
// their progress dictates.
//
// Mirrors the header it replaces — breadcrumb line, then title — so the real
// content doesn't shift in underneath it.
export let CourseStepSkeleton = () => (
  <Box>
    <Skeleton
      variant="text"
      width={220}
      animation="wave"
      sx={{ bgcolor: 'rgba(255,255,255,0.1)' }}
    />
    <Skeleton
      variant="text"
      width="70%"
      height={48}
      animation="wave"
      sx={{ mb: 3, bgcolor: 'rgba(255,255,255,0.1)' }}
    />
    {/* The body is whatever the step turns out to be, and a video is much the most
        likely — so this borrows the player's own skeleton rather than guessing at a
        shape, and the two can't drift. */}
    <VideoPlayerSkeleton />
  </Box>
)

export let CourseOverviewSkeleton = () => (
  <Box>
    <span className="sr-only" role="status" aria-live="polite">
      Loading course overview…
    </span>
    <Skeleton
      variant="rectangular"
      width="100%"
      height={320}
      animation="wave"
      sx={{ bgcolor: 'rgba(255,255,255,0.1)' }}
    />
    <Box
      sx={{
        px: 3,
        py: 4,
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', lg: '2fr 1fr' },
        gap: 4,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Skeleton
          variant="rectangular"
          height={180}
          animation="wave"
          sx={{ borderRadius: 2, bgcolor: 'rgba(255,255,255,0.1)' }}
        />
        <Skeleton
          variant="rectangular"
          height={220}
          animation="wave"
          sx={{ borderRadius: 2, bgcolor: 'rgba(255,255,255,0.1)' }}
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Skeleton
          variant="rectangular"
          height={140}
          animation="wave"
          sx={{ borderRadius: 2, bgcolor: 'rgba(255,255,255,0.1)' }}
        />
        <Skeleton
          variant="rectangular"
          height={120}
          animation="wave"
          sx={{ borderRadius: 2, bgcolor: 'rgba(255,255,255,0.1)' }}
        />
      </Box>
    </Box>
  </Box>
)
